var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"buy-button",class:{'loaded': _vm.isLoading, 'success': _vm.isSuccess},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.addToCart()}}},[_c('span',[_vm._v(_vm._s(_vm.textButton))])])}
var staticRenderFns = []

export { render, staticRenderFns }